export default __webpack_public_path__ + "static/media/ActiveSideArrow.29fc71de.svg";